import React, { useEffect, useState, useCallback } from 'react';
import Modal from "react-bootstrap/Modal";
import { useTranslation } from 'react-i18next';

const IMAGE_URL = process.env.REACT_APP_IMAGE_URL;

const ImagesViewList = ({ attachments, setAttachments, createEmptyRow }) => {
    const { t } = useTranslation();

    // Attachment
    const [attachmentModal, setAttachmentModal] = useState(false);
    const [previewModal, setPreviewModal] = useState(false);
    const [previewImage, setPreviewImage] = useState(null);

    const handleView = (file) => {
        if (!file) return;
        setPreviewImage(file);
        setPreviewModal(true);
    };

    return (
        <div className=''>
            <table className="table table-bordered">
                <thead className="dynoTable">
                    <tr>
                        <th>{t('common.fileName')}</th>
                        <th>{t('common.remarks')}</th>
                        <th>{t('common.upload')}</th>
                        <th>{t('common.view')}</th>
                        <th>{t('common.delete')}</th>
                    </tr>
                </thead>
                <tbody>
                    {attachments.map((row) => (
                        <tr key={row.id}>
                            <td>
                                <input disabled value={row.originalFileName} className="form-control" />
                            </td>

                            <td>
                                <input
                                    disabled
                                    value={row.remarks}
                                    className="form-control"
                                />
                            </td>

                            <td>
                                <input
                                    type="file"
                                    hidden
                                    id={`file-${row.id}`}
                                    disabled
                                />
                                <button
                                    className="mainbtn"
                                    disabled
                                >
                                    {t('common.upload')}
                                </button>
                            </td>

                            <td>
                                <button
                                    className="mainbtnRed"
                                    onClick={() => handleView(row.fullUrl)}
                                >
                                    {t('common.view')}
                                </button>
                            </td>

                            <td>
                                <button
                                    className="mainbtnSecondary"
                                    disabled
                                >
                                    {t('common.delete')}
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <Modal show={previewModal} size="lg" onHide={() => setPreviewModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('common.preview')}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {previewImage && (
                        <img
                            src={previewImage}
                            alt="preview"
                            style={{ width: "100%" }}
                        />
                    )}
                </Modal.Body>
            </Modal>
        </div>
    )
}

export default ImagesViewList